<div class="fuse-vertical-navigation-wrapper">
    <div
        class="fuse-vertical-navigation-content"
        fuseScrollbar
        [fuseScrollbarOptions]="{ wheelPropagation: inner(), suppressScrollX: true }">
        <div role="tree" class="flex flex-col gap-y-1 py-2">
            <ng-container [ngTemplateOutlet]="treeItems" [ngTemplateOutletContext]="{ nodes: navigationSignal() }" />
        </div>
    </div>
</div>

<!-- Item content: icon, title, badge -->
<ng-template #itemContent let-node="node">
    @if (node.icon) {
        <mat-icon class="navigation-item-icon" [svgIcon]="node.icon" />
    }
    <span class="flex-auto truncate">{{ node.title }}</span>
    @if (node.badge) {
        <span class="badge" [ngClass]="node.badge.classes">{{ node.badge.title }}</span>
    }
</ng-template>

<!-- Recursive tree -->
<ng-template let-nodes="nodes" #treeItems>
    @for (node of nodes; track node.id ?? $index) {
        @if (!node.hidden?.(node)) {
            @switch (node.type) {
                @case ('divider') {
                    <div class="navigation-divider"></div>
                }

                @case ('spacer') {
                    <div class="my-1"></div>
                }

                @case ('group') {
                    @if (node.title) {
                        <div class="navigation-group-title">{{ node.title }}</div>
                    }
                    @if (node.children?.length) {
                        <ng-container
                            [ngTemplateOutlet]="treeItems"
                            [ngTemplateOutletContext]="{ nodes: node.children }" />
                    }
                }

                @case ('basic') {
                    @if (node.disabled) {
                        <div
                            role="treeitem"
                            aria-disabled="true"
                            aria-selected="false"
                            class="navigation-item disabled"
                            [matTooltip]="node.tooltip || ''">
                            <ng-container [ngTemplateOutlet]="itemContent" [ngTemplateOutletContext]="{ node }" />
                        </div>
                    } @else if (node.link && node.externalLink) {
                        <a
                            role="treeitem"
                            aria-selected="false"
                            class="navigation-item"
                            [href]="node.link"
                            [target]="node.target || '_self'"
                            [matTooltip]="node.tooltip || ''">
                            <ng-container [ngTemplateOutlet]="itemContent" [ngTemplateOutletContext]="{ node }" />
                        </a>
                    } @else if (node.link) {
                        <a
                            role="treeitem"
                            routerLinkActive="bg-white/10"
                            #rla="routerLinkActive"
                            [attr.aria-selected]="rla.isActive"
                            class="navigation-item"
                            [routerLink]="[node.link]"
                            [routerLinkActiveOptions]="
                                node.isActiveMatchOptions ?? (node.exactMatch ? exactMatchOptions : subsetMatchOptions)
                            "
                            [matTooltip]="node.tooltip || ''"
                            (click)="node.function ? node.function(node) : null">
                            <ng-container [ngTemplateOutlet]="itemContent" [ngTemplateOutletContext]="{ node }" />
                        </a>
                    } @else if (node.function) {
                        <button
                            type="button"
                            role="treeitem"
                            aria-selected="false"
                            class="navigation-item navigation-item-button"
                            [matTooltip]="node.tooltip || ''"
                            (click)="node.function(node)">
                            <ng-container [ngTemplateOutlet]="itemContent" [ngTemplateOutletContext]="{ node }" />
                        </button>
                    }
                }

                @case ('collapsable') {
                    <button
                        type="button"
                        role="treeitem"
                        aria-selected="false"
                        [attr.aria-expanded]="!!node.expanded"
                        class="navigation-item navigation-item-button"
                        [matTooltip]="node.tooltip || ''"
                        (click)="toggleItem(node, nodes)">
                        <ng-container [ngTemplateOutlet]="itemContent" [ngTemplateOutletContext]="{ node }" />
                        <mat-icon
                            class="navigation-item-icon navigation-item-chevron"
                            svgIcon="mat_outline:chevron_right"
                            [class.rotate-90]="node.expanded" />
                    </button>
                    @if (node.expanded && node.children?.length) {
                        <div class="flex flex-col gap-y-1 pl-9">
                            <ng-container
                                [ngTemplateOutlet]="treeItems"
                                [ngTemplateOutletContext]="{ nodes: node.children }" />
                        </div>
                    }
                }
            }
        }
    }
</ng-template>
